// AUTH
export const LOGIN = 'LOGIN'
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN'
export const LOGOUT = 'LOGOUT'
export const SET_USER_PROFILE = 'SET_USER_PROFILE'

// CODES
export const SELECT_CODE = 'SELECT_CODE'
export const CLEAR_CODE_SELECTION = 'CLEAR_CODE_SELECTION'
export const SET_CODE_LIST = 'SET_CODE_LIST'
export const SET_FILTERED_CODE_LIST = 'SET_FILTERED_CODE_LIST'
export const CODE_LOADING = 'CODE_LOADING'
export const CODE_LOADED = 'CODE_LOADED'

// SCM FIELD
export const SET_SCM_FIELD_LIST = 'SET_SCM_FIELD_LIST'
export const SCM_FIELD_LOADING = 'SCM_FIELD_LOADING'
export const SCM_FIELD_LOADED = 'SCM_FIELD_LOADED'

// SNACKBAR
export const SHOW_SNACK_BAR = 'SHOW_SNACK_BAR'
export const DISSMISS_SNACK_BAR = 'DISSMISS_SNACK_BAR'

// COMMON
export const SET_SEARCH = 'SET_SEARCH'

// SETTINGS
export const SET_SETTINGS = 'SET_SETTINGS'

// TRANSACTIONS
export const SELECT_TRANSACTION = 'SELECT_TRANSACTION'
export const TRANSACTION_LOADING = 'TRANSACTION_LOADING'
export const SET_TRANSACTION_LIST = 'SET_TRANSACTION_LIST'
export const TRANSACTION_LOADED = 'TRANSACTION_LOADED'
export const CLEAR_TRANSACTION_SELECTION = 'CLEAR_TRANSACTION_SELECTION'

